module.exports = __webpack_public_path__ + "public/img/Strategi Penjualan Minuman Kekinian.0428cad1.png";